import { defineComponent as _defineComponent } from 'vue'
import { Subsidiary } from '@/models/subsidiary';
import useVuelidate from '@vuelidate/core';
import {
  maxLength,
  maxValue,
  minValue,
  required,
  withLocalizedValidators,
} from '@/utils/validation';
import { helpers } from '@vuelidate/validators';
import { useI18n } from '@/composables/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'SubsidiaryForm',
  props: {
    value: null
  },
  setup(__props: any) {

const props = __props as {
  value: Subsidiary;
};



const { t } = useI18n();

const validations = {
  name: withLocalizedValidators('form.name', {
    required,
    maxLength: maxLength(256),
  }),
  code: withLocalizedValidators('subsidiary.code', {
    required,
    minValue: minValue(1),
    maxValue: maxValue(2147483000),
  }),
};
const v$ = useVuelidate(validations, props.value);

function getErrorMessage(key: keyof typeof props.value) {
  return v$.value[key].$errors?.[0]?.$message;
}

return { __sfc: true,props, t, validations, v$, getErrorMessage }
}

})